import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '../../../utils/date-utils';

@Pipe({
  name: 'currentFormattedDateTime'
})
export class CurrentFormattedDateTimePipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value) return '-';
    return DateUtils.formatDateStringToCurrentDateTime(value);
  }
}
